import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtDT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, MetricCard, ProgressBar, StatusBadge, Loading } from "@/components/Shared";
import { ShoppingCart, ClipboardList, Wallet, Boxes, ArrowRight } from "lucide-react";

export default function SupplierDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [ops, setOps] = useState([]);

  useEffect(() => {
    api.get("/supplier/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/supplier/operations").then((r) => setOps(r.data)).catch(() => {});
  }, []);

  if (!stats) return <Loading />;

  return (
    <div>
      <PageHeader title={user?.supplier_name || "Espace fournisseur"} subtitle="Suivez vos opérations et commandes en temps réel." />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <MetricCard testId="sup-metric-ops" label="Opérations" value={stats.operations} icon={ShoppingCart} tone="indigo" />
        <MetricCard testId="sup-metric-open" label="Ouvertes" value={stats.open_operations} icon={ShoppingCart} tone="emerald" />
        <MetricCard testId="sup-metric-orders" label="Commandes reçues" value={stats.orders} icon={ClipboardList} tone="sky" />
        <MetricCard testId="sup-metric-volume" label="Volume engagé" value={fmtDT(stats.total_committed)} icon={Wallet} tone="amber" />
      </div>

      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-slate-900">Mes opérations</h3>
        <Link to="/supplier/operations" className="text-sm font-semibold text-indigo-600 hover:underline flex items-center gap-1">Tout voir <ArrowRight className="h-3.5 w-3.5" /></Link>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {ops.slice(0, 4).map((op) => (
          <div key={op.id} className="bg-white border border-slate-200 rounded-xl p-5">
            <div className="flex items-start justify-between gap-2">
              <div className="font-bold text-slate-900 line-clamp-1">{op.name}</div>
              <StatusBadge status={op.status} />
            </div>
            <div className="mt-4"><ProgressBar current={op.committed_amount} target={op.objective_amount} /></div>
            <div className="mt-3 text-xs font-semibold text-slate-500">{op.participants_count} pharmacies participantes</div>
          </div>
        ))}
        {ops.length === 0 && <div className="text-sm text-slate-400">Aucune opération pour le moment.</div>}
      </div>
    </div>
  );
}
